import React, { useEffect, useState, useContext, useRef } from 'react';
import { Divider, Typography, Grid, Link, Box, Container, CircularProgress} from '@mui/material';
import Constants from '../../utils/Constants';
import { useTranslation } from 'react-i18next';
import { fetchImageFromAzureBlobStorage, fetchContentFromAzureBlobStorage } from '../../data/Contentapi';
import DOMPurify from 'dompurify';
import { MyContext } from '../../globalContext';
import {  validate } from '../../data/Contentapi.js';
import { getConfig } from "../../loadconfig";
import ReCaptcha from 'react-google-recaptcha';
import CancelIcon from '@mui/icons-material/Cancel';



const Footer = () => {
  
  const { t } = useTranslation();
  const [footerLogoSrc, setFooterLogoSrc] = useState('');
  const sanitizedSelfVerifyText = DOMPurify.sanitize(t('selfVerifyText'));
  const { languageData, jwtToken, setRecaptchaTokenData,setJwtTokenData, setSessionIdData, setTokenSessionTimeData } = useContext(MyContext);
  const { recaptcha3Validated, setRecaptcha3ValidatedData } = useContext(MyContext);
  const recaptchaRef = useRef(null);
  const [errorRecaptcha, setErrorRecaptcha] = useState(false);
  const [generalDisclaimer, setGeneralDisclaimer] = useState([]);
  let timeoutJwt = undefined;
  let config = getConfig();
  const mycontext = useContext(MyContext);
  const contextRef = useRef(mycontext);
  const timeoutPeriodForJwtCheck = 1 * 60 * 1000; // 1 minutes in milliseconds

  useEffect(() => {
    contextRef.current = mycontext;
}, [mycontext]);

  const handleJwtReset = (mycontextp) => {
    const { jwtToken, tokenSessionTime, setJwtTokenData, sessionTimeExp } = mycontextp;

    if(jwtToken && !sessionTimeExp) {
      console.log("checking jwt time .");
      const currentTime = new Date().getTime();
      
      if (currentTime - tokenSessionTime >= (7 * 60 * 1000)) { // 7 minutes
        console.log("resetting token .");
        setJwtTokenData(""); // reset to generate new, it is done in Footer.js
      } 
  } 
  clearTimeout(timeoutJwt);
  //needs only when no session time exp
  if(!sessionTimeExp) {
    setTimeout(() => handleJwtResetWithContext(), timeoutPeriodForJwtCheck);
  }

  }

  const handleJwtResetWithContext = () => {
    handleJwtReset(contextRef.current);
};

  const getFooterLogo = async () => {
    try {
      const imageData = await fetchImageFromAzureBlobStorage(Constants.MPI_FOOTER_LOGO_FILENAME);
      setFooterLogoSrc(`data:${imageData.contentType};base64,${imageData.imageString}`);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getGeneralDisclaimer();
  }, [languageData]);

  useEffect(() => {
    getFooterLogo();
    console.log("calling jwt reset - first time");
    handleJwtResetWithContext();
    
  }, []);
  
  const handleRecaptcha2Change = (token) => {
    setErrorRecaptcha(false);
    setRecaptchaTokenData(token);
    
    validate(config.VALIDATE_URL, "recaptcha2",token).then((dataResponse) => {
        
        if(dataResponse.meta && dataResponse.meta.statusCode === "A") {
            setJwtTokenData("");
            setSessionIdData(false);
            setRecaptchaTokenData("");
        }
        const jwttoken = dataResponse.jwttoken;
        setTokenSessionTimeData(new Date().getTime());
        setJwtTokenData(jwttoken);
        setSessionIdData(true);
    }).catch((error) => {
        console.error(error.message);
        //TODO Need to display session expired message Auth error
    });
    
};

  useEffect(() => {
    if(!jwtToken || jwtToken === "") {
      const script = document.createElement('script');
      script.src =  Constants.RECAPTCHA_URL + config.RECAPTCHAV3SITEKEY;
      script.async = true;
      script.onload = () => {
        console.log('ReCaptcha script loaded');
        if (window.grecaptcha) {
          window.grecaptcha.ready(function() {
            window.grecaptcha.execute(config.RECAPTCHAV3SITEKEY, {action: 'submit'}).then(function(token) {
              // Add your logic to submit to your backend server here.

              validate(config.VALIDATE_URL, "recaptcha3",token).then((dataResponse) => {
            
                if(dataResponse.meta && dataResponse.meta.statusCode === "A") {
                    setJwtTokenData("");
                    setRecaptchaTokenData("");
                    setSessionIdData(false);

                }else{
                  const jwttoken = dataResponse.jwttoken;
                  setTokenSessionTimeData(new Date().getTime());
                  setJwtTokenData(jwttoken);
                  setSessionIdData(true);

                }
                setRecaptcha3ValidatedData(true);
    
            }).catch((error) => {
                console.error(error.message);
                setJwtTokenData("");
                setSessionIdData(false);
                setRecaptchaTokenData("");
                setRecaptcha3ValidatedData(true);
                //TODO Need to display session expired message Auth error
            });

          });
        });
      }
      };
      document.body.appendChild(script);
    }
  }, [jwtToken]);

  const getGeneralDisclaimer = async () => {

    try {
        const generalDisclaimerContent = await fetchContentFromAzureBlobStorage(
            languageData.toLowerCase(),
             "Disclaimers",
             "DISCLAIMER_GENERAL"
            );
        setGeneralDisclaimer(generalDisclaimerContent.contentData);           

    } catch (e) {
        console.log(e.message);

    }
}
const sanitizedgeneralDisclaimer = DOMPurify.sanitize(generalDisclaimer);

  return (
    <>
    <Container sx={{width: "100%", marginY:"2%" }} fixed >
    {(jwtToken == undefined || jwtToken == "") && <div className="recaptchaDiv ml-5" >  
      {recaptcha3Validated && <>
      <ReCaptcha
            ref={recaptchaRef}
                sitekey={config.RECAPTCHASITEKEY}
                onChange={handleRecaptcha2Change}
                onErrored={() => {
                    //do nothing
                  }}
            />
                {errorRecaptcha && <div className="error-bubble-recaptcha">
                            <div><CancelIcon className="error-icon" /></div>
                            
            </div> }
            </> 
                }

                {!recaptcha3Validated &&  <Box alignItems="center" sx={{marginX:"2.5%"}}>
                  <CircularProgress data-testid='loading-circle' color="primary" />
                  </Box>
                }

            </div>
            }
            </Container>
     <Container sx={{width: "100%", marginY:"2%" }} fixed >
      <Box mx={8}>
        <Divider sx={{ borderBottomWidth: 2 }} />
        <Grid container pt={3} pb={2}>
          <Grid item xs={12} md={6} data-testid='footer-left-section' id='footer-left-section'>
            <Typography  align='left' fontWeight='bold' sx={{fontSize: "29px"}}>{t('needHelpText')}</Typography>
            <Divider sx={{ borderWidth: 4, maxWidth: '46px', borderColor: '#007839',marginTop: "8px" }} />
            <Typography variant='body2' align='left' pt={2} >{t('translatorCallText')}
              <Link href="tel:866-981-7427" data-testid="trans-service-phone" >{Constants.TRANSLATOR_SERVICE_PHONE}</Link><div>{t('holdForRepText')}</div>
            </Typography>
            <Typography variant='body2' align='left'  data-testid='period'>{t('ttyCallText')}<Link href="tel:866-918-7427" data-testid='tty-ttd-service-phone'>
              {Constants.TTY_TTD_SERVICE_PHONE}</Link>{Constants.PERIOD}
            </Typography>
            <Typography variant='body2' align='left' pt={2}><Link href="mailto:reportabarrier@claritev.com" >{t('report')}{t('adaBarrierText')}</Link></Typography>
          </Grid>
          <Grid item xs={12} md={6} data-testid='footer-right-section' id='footer--right-section'>
            <Typography variant='body2' align='left' pb={2} sx={{fontSize: "16px"}}>{t('noteGrntyText')}</Typography>
            <Typography variant='body2' align='left' dangerouslySetInnerHTML={{
              __html: sanitizedSelfVerifyText
            }} ></Typography>
            
          </Grid>
        </Grid>
      </Box>



      <Box mx={8}> 
      {generalDisclaimer && ( <Divider sx={{ borderBottomWidth: 2 }} />  )}   
      <div style={{textAlign: "left", fontSize: "14px"}} >
       {generalDisclaimer && (
       <div dangerouslySetInnerHTML={{ __html: sanitizedgeneralDisclaimer }} />
        )}                                         
      </div>
      </Box>
      </Container>


     
     

      <Box item xs={12} sm={12} lg={7} md={7} id='footer-logo-section' sx={{ color: 'white', backgroundColor: '#37383c'}} py={4} px={5}>
        <Typography id='footer-logo' sx={{ display: 'flex' }}>
          <img
            src={footerLogoSrc}
            alt="MPI Footer Logo"
            className="footer-logo"
            // style={{ width: '10%', height: 'auto', maxWidth: '180px' }}
          />
        </Typography>

        <Typography id='footer-links' data-testid='footer-links' variant='body2' align='left' py={1}> &copy; {(new Date().getFullYear())} {Constants.FOOTER_INFO_TXT} |
          <Link href={Constants.TERMS_URL} target="_blank" rel="noopener noreferrer" data-testid={Constants.TERMS_LINK} style={{ color: 'white', textDecorationColor: 'white' }}>
            {Constants.TERMS}
          </Link> |
          <Link href={Constants.PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" data-testid={Constants.PRIVACY_POLICY_LINK} style={{ color: 'white', textDecorationColor: 'white' }}>
            {Constants.PRIVACY_POLICY}
          </Link>
        </Typography>
      </Box>
    </>
  );
}

export default Footer; 